/* eslint-disable import/prefer-default-export */

export class GtmConstants {
  static EVENT = 'gaEvent';

  static MD_LABEL = 'MD';

  static ME_LABEL = 'ME';

  static MK_LABEL = 'MK';

  static EB_LABEL = 'EB';

  static UNDEF = 'undefined';

  static FALSE = 'false';

  static AC_TYPE = 'areacliente';

  static MI_CUENTA = 'mi_cuenta';

  static MIS_VENTAJAS = 'mis_ventajas';

  static UPGRADE_CATEGORY = 'UPGRADE';

  static ARE_CLIENTE_CATEGORY = 'area cliente';

  static CUPONES_CATEGORY = 'cupones';

  static NORO_ACTION = 'NORO';

  static LINK_CABECERA_ACTION = 'links-cabecera';

  static ACTIVAR_VALE_ACTION = 'activacion - club eroski';

  static MENU_ACTION = 'menu';

  static MENU_ACTION_CTA = 'cta_body';

  static MENU_NONE = 'none';

  static LOGOUT = 'LOGOUT';

  static GOLD_CARD_REQUEST = 'request_gold_card';

  static GOLD_CARD_ITERATION = 'interaction';

  static GOLD_CARD = 'tarjeta oro';

  static MASTER_CARD = 'tarjeta mastercard';

  static ALTA_ORO_STEP = 'paso 1';
}
